export const IconConnections = ({ size = 21, className }) => {
  return (
    <i
      style={{ width: size, height: size }}
      className={`flex items-center justify-center ${className}`}
    >
      <svg
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g>
          <path
            id="Vector"
            d="M5.9593 41.7623H10.6468C12.1906 41.7623 13.4484 40.5061 13.4484 38.9607V34.2732C13.4484 32.7279 12.1905 31.4716 10.6468 31.4716H9.86555V29.4231C9.86555 28.5621 10.5656 27.8606 11.428 27.8606H23.4376V31.4716H22.6564C21.1126 31.4716 19.8548 32.7278 19.8548 34.2732V38.9607C19.8548 40.5059 21.1126 41.7623 22.6564 41.7623H27.3439C28.8877 41.7623 30.1455 40.5061 30.1455 38.9607V34.2732C30.1455 32.7279 28.8876 31.4716 27.3439 31.4716H26.5626V27.8606H38.5722C39.4347 27.8606 40.1347 28.5621 40.1347 29.4231V31.4716H39.3535C37.8097 31.4716 36.5519 32.7278 36.5519 34.2732V38.9607C36.5519 40.5059 37.8097 41.7623 39.3535 41.7623H44.041C45.5848 41.7623 46.8426 40.5061 46.8426 38.9607V34.2732C46.8426 32.7279 45.5847 31.4716 44.041 31.4716H43.2597V29.4231C43.2597 26.8388 41.1565 24.7356 38.5722 24.7356H26.5626V18.5231H27.3439C28.8877 18.5231 30.1455 17.2669 30.1455 15.7215V11.034C30.1455 9.48876 28.8876 8.23242 27.3439 8.23242H22.6564C21.1126 8.23242 19.8548 9.48859 19.8548 11.034V15.7215C19.8548 17.2668 21.1126 18.5231 22.6564 18.5231H23.4376V24.7356L11.428 24.7358C8.84376 24.7358 6.74055 26.839 6.74055 29.4233V31.4718H5.9593C4.41551 31.4718 3.15771 32.7279 3.15771 34.2733V38.9608C3.15771 40.5061 4.41555 41.7624 5.9593 41.7624V41.7623ZM43.7156 34.5964V38.6371H39.6748V34.5964H43.7156ZM22.9797 15.3981V11.3574H27.0204V15.3981H22.9797ZM27.0204 34.5964V38.6371H22.9797V34.5964H27.0204ZM6.28459 34.5964H10.3253V38.6371H6.28459V34.5964Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </i>
  );
};
